import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import { interviewAPI } from '../services/api';

export default function History() {
  const navigate = useNavigate();
  const [interviews, setInterviews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    interviewAPI.history()
      .then(res => setInterviews(res.data.interviews || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const gradeClass = (g) => {
    if (!g) return 'grade-C';
    if (g.startsWith('A')) return 'grade-A';
    if (g.startsWith('B')) return 'grade-B';
    if (g.startsWith('C')) return 'grade-C';
    return 'grade-D';
  };

  const modeIcon = (m) => {
    if (m === 'text_chat') return '💬';
    if (m === 'mcq') return '📝';
    return '🎙️';
  };

  return (
    <div className="app-layout">
      <Sidebar />
      <main className="main-content">
        <div className="page-header">
          <div className="page-title">Interview History</div>
          <div className="page-subtitle">Review your past mock interviews and track progress</div>
        </div>

        {loading ? (
          <div style={{ textAlign: 'center', padding: 48 }}><span className="spinner" /></div>
        ) : interviews.length === 0 ? (
          <div className="card card-lg" style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>📋</div>
            <div style={{ fontWeight: 600, fontSize: 18, marginBottom: 8 }}>No interviews yet</div>
            <p style={{ color: 'var(--text-secondary)', marginBottom: 20 }}>Start your first mock interview to see results here.</p>
            <button className="btn btn-primary" onClick={() => navigate('/interview/setup')}>Start Interview</button>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {interviews.map(iv => (
              <div key={iv.id} className="card" style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 20, transition: 'all 0.2s' }}
                onClick={() => iv.status === 'completed' ? navigate(`/interview/${iv.id}/report`) : null}
                onMouseOver={e => e.currentTarget.style.boxShadow = 'var(--shadow-lg)'}
                onMouseOut={e => e.currentTarget.style.boxShadow = 'var(--shadow)'}>

                <div style={{ fontSize: 32 }}>{modeIcon(iv.mode)}</div>

                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 600, fontSize: 15, marginBottom: 4 }}>{iv.job_role || 'General Interview'}</div>
                  <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                    <span className="tag tag-primary">{iv.mode?.replace('_', ' ')}</span>
                    <span className="tag" style={{ background: 'var(--bg)', border: '1px solid var(--border)' }}>{iv.interview_type}</span>
                    <span className="tag" style={{ background: 'var(--bg)', border: '1px solid var(--border)' }}>{iv.difficulty}</span>
                  </div>
                </div>

                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: 13, color: 'var(--text-secondary)' }}>Questions</div>
                  <div style={{ fontWeight: 600 }}>{iv.answered_questions}/{iv.total_questions}</div>
                </div>

                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: 13, color: 'var(--text-secondary)' }}>Score</div>
                  <div style={{ fontWeight: 600 }}>{iv.overall_score ? `${iv.overall_score}/10` : '-'}</div>
                </div>

                <div style={{ textAlign: 'center' }}>
                  {iv.grade ? (
                    <span className={`grade-badge ${gradeClass(iv.grade)}`} style={{ width: 36, height: 36, fontSize: 15 }}>{iv.grade}</span>
                  ) : (
                    <span className={`tag ${iv.status === 'completed' ? 'tag-success' : iv.status === 'in_progress' ? 'tag-amber' : 'tag-danger'}`}>{iv.status}</span>
                  )}
                </div>

                <div style={{ fontSize: 13, color: 'var(--text-muted)', minWidth: 80, textAlign: 'right' }}>
                  {new Date(iv.started_at).toLocaleDateString()}
                </div>
              </div>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}
